// import auth from 'app/auth/store/reducers';
import { combineReducers } from '@reduxjs/toolkit';
import fuse from './fuse';
import site from './site.reducer';
import market from './market.reducer';
import app from './app.reducer';
import profile from './profile.reducer';
import licenseGroups from './licenseGroups.reducer';
import users from './users.reducer';
import userGroups from './userGroups.reducer';
import devices from './devices.reducer';
import deviceGroups from './deviceGroups.reducer';
import jobNames from './jobNames.reducer';
import jobNameGroups from './jobNameGroups.reducer';
import apps from './apps.reducer';
import appGroups from './appGroups.reducer';
import prints from './prints.reducer';
import printGroups from './printGroups.reducer';
import scheduledReports from './scheduledReports.reducer';
import notifications from './notifications.reducer';
import notificationGroups from './notificationGroups.reducer';
import inputNodes from './inputNodes.reducer';
import directPrintAgents from './directPrintAgents.reducer';
import roles from './roles.reducer';
import forms from './forms.reducer';
import formGroups from './formGroups.reducer';
import sampleWorkflows from './sampleWorkflows.reducer';
import workflows from './workflows.reducer';
import workflowGroups from './workflowGroups.reducer';
import logs from './logs.reducer';
import alertSubscriptions from './alertSubscriptions.reducer';
import mpDevices from './mpDevices.reducer';
import mpForms from './mpForms.reducer';
import mpWorkflows from './mpWorkflows.reducer';
import report from './report.reducer';
import people from './people.reducer';
import entitlements from './entitlements.reducer';
import mfa from './mfa.reducer';
import bsn from './bsn.reducer';
import auth from './auth.reducer';
import storage from './storage.reducer';

const reducer = combineReducers({
	// auth,
	fuse,
	site,
	market,
	app,
	profile,
	licenseGroups,
	users,
	userGroups,
	devices,
	deviceGroups,
	apps,
	appGroups,
	prints,
	printGroups,
	scheduledReports,
	notifications,
	notificationGroups,
	jobNames,
	jobNameGroups,
	inputNodes,
	directPrintAgents,
	roles,
	forms,
	formGroups,
	sampleWorkflows,
	workflows,
	workflowGroups,
	logs,
	alertSubscriptions,
	mpDevices,
	mpForms,
	mpWorkflows,
	report,
	people,
	entitlements,
	mfa,
	bsn,
	auth,
	storage,
});

export default reducer;

// Selectors
export * from './site.reducer';
export * from './market.reducer';
export * from './app.reducer';
export * from './profile.reducer';
export * from './licenseGroups.reducer';
export * from './users.reducer';
export * from './userGroups.reducer';
export * from './devices.reducer';
export * from './deviceGroups.reducer';
export * from './jobNames.reducer';
export * from './jobNameGroups.reducer';
export * from './apps.reducer';
export * from './appGroups.reducer';
export * from './prints.reducer';
export * from './printGroups.reducer';
export * from './scheduledReports.reducer';
export * from './notifications.reducer';
export * from './notificationGroups.reducer';
export * from './inputNodes.reducer';
export * from './directPrintAgents.reducer';
export * from './roles.reducer';
export * from './forms.reducer';
export * from './formGroups.reducer';
export * from './sampleWorkflows.reducer';
export * from './workflows.reducer';
export * from './workflowGroups.reducer';
export * from './logs.reducer';
export * from './alertSubscriptions.reducer';
export * from './mpDevices.reducer';
export * from './mpForms.reducer';
export * from './mpWorkflows.reducer';
export * from './report.reducer';
export * from './people.reducer';
export * from './entitlements.reducer';
export * from './mfa.reducer';
export * from './bsn.reducer';
export * from './auth.reducer';
export * from './storage.reducer';
